import Pricing1 from './Pricing1'
export default Pricing1
